export enum INAAction{
    New=1,
    Edit=2,
    View=3,
    NoAction=4
}